var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[(_vm.currentPage)?_c(_vm.currentPage,{tag:"component"}):_c('div',{staticClass:"placeholder-page"},[_c('div',{staticClass:"placeholder-icon"},[_vm._v("🚧")]),_c('div',{staticClass:"placeholder-text"},[_vm._v("页面开发中...")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }